var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lebot-info",class:_vm.type},[_c('i',{staticClass:"fa small mr-1",class:_vm.type ? `fa-${_vm.type}` : 'fa-info-circle'}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }